const AMPLIFY_REGION = process.env.REACT_APP_AMPLIFY_REGION;
const AMPLIFY_POOL_ID = process.env.REACT_APP_AMPLIFY_POOL_ID;
const AMPLIFY_CLIENT_ID = process.env.REACT_APP_AMPLIFY_CLIENT_ID;
const AMPLIFY_DOMAIN = process.env.REACT_APP_AMPLIFY_DOMAIN;
const REACT_URL = process.env.REACT_APP_URL;

export { AMPLIFY_REGION, AMPLIFY_POOL_ID, AMPLIFY_CLIENT_ID, AMPLIFY_DOMAIN, REACT_URL };
